@if (isAuthRoute()) {
<router-outlet />
} @else if (showCanteenShell()) {
<div class="h-screen overflow-hidden bg-slate-50 text-slate-800">
  <app-sidebar
    [isOpen]="isSidebarOpen()"
    [navItems]="navItems()"
    brandLabel="Cantina"
    (closeSidebar)="onCloseSidebar()"
  />

  <button
    type="button"
    class="fixed top-[25px] z-[70] hidden size-5 -translate-y-1/2 items-center justify-center rounded-full border border-white/30 bg-white text-slate-700 shadow-sm outline-none transition-all duration-300 ease-in-out hover:bg-slate-50 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 active:outline-none lg:inline-flex"
    [ngClass]="{
      'left-[calc(300px-0.625rem)]': isSidebarOpen(),
      'left-[calc(4rem-0.625rem)]': !isSidebarOpen(),
    }"
    (click)="onToggleSidebar()"
    [attr.aria-expanded]="isSidebarOpen()"
    aria-controls="application-sidebar"
    aria-label="Alternar sidebar"
  >
    <span class="sr-only">Alternar sidebar</span>
    <i
      class="bi bi-chevron-left text-xs leading-none"
      aria-hidden="true"
      [class.rotate-180]="!isSidebarOpen()"
    ></i>
  </button>

  @if (isSidebarOpen()) {
  <div
    class="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm transition-opacity lg:hidden"
    (click)="onToggleSidebar()"
    aria-hidden="true"
  ></div>
  }

  <div
    class="relative flex h-full min-w-0 flex-col transition-all duration-300"
    [ngClass]="{
      'lg:ms-[300px]': isSidebarOpen(),
      'lg:ms-16': !isSidebarOpen(),
    }"
  >
    <header
      class="fixed left-0 right-0 top-0 z-50 h-[50px] border-b border-gray-200 bg-white transition-all duration-300"
      [ngClass]="{
        'lg:left-[300px]': isSidebarOpen(),
        'lg:left-16': !isSidebarOpen(),
      }"
    >
      <nav
        class="relative flex h-full w-full min-w-0 items-center justify-between gap-2 px-2 sm:px-3 md:px-4 lg:px-6"
        aria-label="Cabeçalho"
      >
        <div class="flex min-w-0 items-center gap-x-2">
          <button
            type="button"
            class="inline-flex size-9 shrink-0 items-center justify-center rounded border border-transparent text-gray-800 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none lg:hidden"
            (click)="onToggleSidebar()"
            aria-controls="application-sidebar"
            aria-label="Alternar sidebar"
          >
            <span class="sr-only">Alternar sidebar</span>
            <i class="bi bi-list text-lg leading-none" aria-hidden="true"></i>
          </button>
          <span class="min-w-0 truncate text-sm font-medium text-gray-700">
            {{ canteen.school.name }} - {{ canteen.unit().name }}
          </span>
        </div>

        <div class="flex items-center gap-2">
          <div class="relative inline-flex">
            <button
              id="canteen-notices-toggle"
              type="button"
              class="relative inline-flex size-9 items-center justify-center rounded text-gray-700 hover:bg-gray-100"
              [attr.aria-expanded]="noticesOpen()"
              aria-controls="canteen-notices"
              aria-label="Notificações"
              (click)="toggleNotices()"
            >
              <i class="bi bi-bell" aria-hidden="true"></i>
              @if (canteen.visibleNotices().length > 0) {
              <span
                class="absolute right-1 top-1 size-2 rounded-full bg-[var(--color-primary)]"
              ></span>
              }
            </button>
            <div
              id="canteen-notices"
              class="absolute end-0 z-60 mt-[40px] w-80 rounded border border-gray-200 bg-white p-2 shadow-lg"
              [hidden]="!noticesOpen()"
            >
              <p class="px-2 py-1 text-sm font-medium text-gray-800">
                Notificações
              </p>
              <div class="max-h-64 overflow-y-auto">
                @for (notice of canteen.visibleNotices(); track notice.id) {
                <article class="rounded px-2 py-2 hover:bg-gray-50">
                  <p class="text-sm font-medium text-gray-800">
                    {{ notice.title }}
                  </p>
                  <p class="text-xs text-gray-500">{{ notice.body }}</p>
                </article>
                }
              </div>
            </div>
          </div>

          <div class="relative inline-flex">
            <button
              id="canteen-user-menu-toggle"
              type="button"
              class="relative inline-flex items-center gap-x-2 text-sm font-medium transition"
              aria-haspopup="menu"
              aria-controls="canteen-user-menu"
              [attr.aria-expanded]="isUserMenuOpen()"
              aria-label="Menu do usuário"
              (click)="toggleUserMenu()"
            >
              <ui-user-avatar
                [name]="accountName()"
                [src]="profileAvatarUrl()"
                size="xs"
              />
            </button>

            <div
              id="canteen-user-menu"
              class="absolute end-0 z-60 mt-[40px] min-w-72 rounded border border-gray-200 bg-white p-2 shadow-lg"
              role="menu"
              aria-labelledby="canteen-user-menu-toggle"
              [hidden]="!isUserMenuOpen()"
            >
              <div
                class="mb-2 flex items-center gap-3 border-b border-gray-200 px-2 pb-3 pt-1"
              >
                <ui-user-avatar
                  [name]="accountName()"
                  [src]="profileAvatarUrl()"
                />
                <div class="min-w-0">
                  <p class="truncate text-sm font-semibold text-gray-800">
                    {{ accountName() }}
                  </p>
                  <p class="truncate text-xs text-gray-500">
                    {{ accountRoleLabel() }}
                  </p>
                  <p class="mt-0.5 truncate text-xs text-gray-400">
                    Visão: {{ viewModeLabel() }}
                  </p>
                </div>
              </div>
              <p class="px-3 pb-1 text-xs font-medium text-gray-500">
                Modo de visualização
              </p>
              @for (profile of canteen.profiles; track profile.id) {
              <button
                type="button"
                class="flex w-full items-center justify-between gap-x-3 rounded px-3 py-2 text-left text-sm hover:bg-gray-100"
                [ngClass]="{
                  'bg-slate-100 font-medium text-gray-900':
                    profile.id === activeViewProfileId(),
                  'text-gray-700': profile.id !== activeViewProfileId(),
                }"
                (click)="useViewMode(profile.id)"
              >
                <span>{{ roleLabels[profile.role] }}</span>
                @if (profile.id === activeViewProfileId()) {
                <i
                  class="bi bi-check2 text-base text-[var(--color-primary)]"
                  aria-hidden="true"
                ></i>
                }
              </button>
              }
              <a
                routerLink="/profile"
                class="mt-1 flex w-full items-center gap-x-3 rounded px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                (click)="closeMenus()"
              >
                <i
                  class="bi bi-person-circle text-base leading-none"
                  aria-hidden="true"
                ></i>
                Meu perfil
              </a>
              <button
                type="button"
                class="mt-1 flex w-full items-center gap-x-3 rounded px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                (click)="signOut()"
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <main
      class="min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain px-3 pt-3 pb-24 sm:px-4 sm:pt-4 lg:px-6 lg:pt-6"
      style="margin-top: 50px"
    >
      <router-outlet />
    </main>
  </div>
</div>
} @else {
<div class="flex min-h-screen items-center justify-center bg-slate-50 p-4">
  <app-preloader message="Redirecionando para o login" variant="inline" />
</div>
}
